<template>
  <div class="km__modules__designcheck km__popup">
    <button class="km__button--back" type="button" name="back" @click="closeDesignCheck" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="closeDesignCheck" aria-label="close"></button>
    <div class="km__popup--heading">
      <h2>{{ $t("konf_designcheck_header") }}</h2>
    </div>
    <div class="km__popup--content" v-if="!hasLogos">
      <p>{{ $t("konf_designcheck_nologos") }}</p>
      <div class="km__popup--buttons">
        <button class="km__button--standard" @click="closeDesignCheck">{{ $t("konf_OK") }}</button>
        <button class="km__button--standard blue" @click="openContactForm">{{
            $t("konf_kontaktformular_fuer_button")
          }}
        </button>
      </div>
    </div>
    <div v-else>
      <p class="intro" v-html="t('konf_Designcheck')"></p>
      <BasicContactForm @close="closeDesignCheck" @send="send"/>
    </div>

  </div>
</template>

<script lang="ts" setup>
import {useStore} from "vuex";
import {globalsObject, translate} from "@k/js/globalsObject";
import BasicContactForm from "@km/components/popups/BasicContactForm.vue";
import {displayTwoButtonDialog} from "@km/components/popups/ConfirmOrConfirmCancelDialog";
import type {BasicContactFormData} from "@km/components/popups/BasicContactFormData";
import {getHelpAnfrageParameters, sendGetHelpForm} from "@km/mixins/sendGetHelpForm";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";
import {UserModuleNames} from "@km/components/user/UserModulesAnimations";
import {useI18n} from "vue-i18n";
const t = translate;
const i18n = useI18n();
const store = useStore();
const send = (formdata: BasicContactFormData) => {
  globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_SUBMIT_DESIGNCHECK);
  globalsObject.actionController.saveEntwurfIfNeedsSaving(false).then(
      () => sendGetHelpForm(getHelpAnfrageParameters(formdata, "Designanfrage", "Designcheck"), store, i18n).then(() => closeDesignCheck()))
};
const hasLogos = store.getters.getLogoObjects.length > 0;
function displayNoDesigncheckWithoutLoginDialog() {
  displayTwoButtonDialog(
      t("konf_contactOwayo_DesigncheckTitle"),
      t("konf_designcheck_login_needed"),
      "konf_designcheck_login_ok", "konf_Cancel"
      , true
      ).then(()=>{
        closeDesignCheck();
        store.commit("OPEN_USERLAYER", UserModuleNames.login)
  }).catch(()=>closeDesignCheck())
}

if(!store.getters.isLoggedIn) {
  displayNoDesigncheckWithoutLoginDialog();
}

const closeDesignCheck = () => store.commit("SET_OVERLAY_CLOSED", 'designcheck');
const openContactForm = () => store.commit("SET_OVERLAY_OPEN", 'contactform');

</script>

<style lang="scss" scoped>
.km__modules__designcheck {
  z-index: 999;
  overflow-y: scroll;
}
</style>
